// frontend/src/features/campaign/utils/dateUtils.js

// ── Date Utility Helpers (Timezone-safe) ──
export function parseLocalDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const parts = dateStr.split('-').map(Number);
  if (parts.length !== 3 || parts.some(isNaN)) return null;
  return new Date(parts[0], parts[1] - 1, parts[2]);
}

export function formatLocalDate(date) {
  if (!date || isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function addDays(dateStr, days) {
  const dt = parseLocalDate(dateStr);
  if (!dt) return '';
  dt.setDate(dt.getDate() + Number(days));
  return formatLocalDate(dt);
}

export function calculateDiffDays(startStr, endStr) {
  const dt1 = parseLocalDate(startStr);
  const dt2 = parseLocalDate(endStr);
  if (!dt1 || !dt2) return 0;
  const diffTime = dt2.getTime() - dt1.getTime();
  return Math.max(0, Math.round(diffTime / (1000 * 60 * 60 * 24)));
}

export function formatDisplayDate(dateStr) {
  const dt = parseLocalDate(dateStr);
  if (!dt) return '—';
  return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
